import React, { createContext, useContext, useState, useCallback } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [cartItem, setCartItem] = useState(null);

  const addToCart = useCallback((item) => {
    setCartItem(item);
    localStorage.setItem("eversky_cart", JSON.stringify(item));
  }, []);

  const clearCart = useCallback(() => {
    setCartItem(null);
    localStorage.removeItem("eversky_cart");
  }, []);

  const loadCart = useCallback(() => {
    const saved = localStorage.getItem("eversky_cart");
    if (saved) {
      setCartItem(JSON.parse(saved));
    }
  }, []);

  return (
    <CartContext.Provider value={{ cartItem, addToCart, clearCart, loadCart }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error("useCart must be used within CartProvider");
  }
  return context;
};
